/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query'
import type {
  MutationFunction,
  UseMutationOptions
} from '@tanstack/react-query'
import type {
  AuthenticateUser200,
  AuthenticateUserBody,
  BadRequestResponse,
  CompleteNewPassword200,
  CompleteNewPasswordBody,
  ForbiddenResponse,
  ForgotPassword200,
  ForgotPasswordBody,
  InternalServerErrorResponse,
  LogoutUser200,
  NotFoundResponse,
  PasswordlessInitiate200,
  PasswordlessInitiateBody,
  PasswordlessVerify200,
  PasswordlessVerifyBody,
  RefreshAccessToken200,
  RefreshAccessTokenBody,
  ResetPassword200,
  ResetPasswordBody,
  UnauthorizedResponse
} from '.././model'
import { customInstance } from '../../custom-instance';


// eslint-disable-next-line
  type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;


/**
 * This endpoint allows a user to log in by providing their email and password. Upon successful authentication, it returns a JWT token, which can be used for authorization in subsequent requests.
 * @summary Authenticate a user and return a JWT token
 */
export const authenticateUser = (
    authenticateUserBody: AuthenticateUserBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<AuthenticateUser200>(
      {url: `https://api.app.usesky.ai/login`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: authenticateUserBody
    },
      options);
    }
  


export const getAuthenticateUserMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateUser>>, TError,{data: AuthenticateUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof authenticateUser>>, TError,{data: AuthenticateUserBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authenticateUser>>, {data: AuthenticateUserBody}> = (props) => {
          const {data} = props ?? {};

          return  authenticateUser(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type AuthenticateUserMutationResult = NonNullable<Awaited<ReturnType<typeof authenticateUser>>>
    export type AuthenticateUserMutationBody = AuthenticateUserBody
    export type AuthenticateUserMutationError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Authenticate a user and return a JWT token
 */
export const useAuthenticateUser = <TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authenticateUser>>, TError,{data: AuthenticateUserBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getAuthenticateUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Starts passwordless authentication flow by sending an OTP code to the user's email.
Uses Cognito Custom Auth flow with Lambda triggers.

 * @summary Initiate passwordless authentication
 */
export const passwordlessInitiate = (
    passwordlessInitiateBody: PasswordlessInitiateBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PasswordlessInitiate200>(
      {url: `https://api.app.usesky.ai/auth/passwordless/initiate`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: passwordlessInitiateBody
    },
      options);
    }
  


export const getPasswordlessInitiateMutationOptions = <TError = BadRequestResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordlessInitiate>>, TError,{data: PasswordlessInitiateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof passwordlessInitiate>>, TError,{data: PasswordlessInitiateBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordlessInitiate>>, {data: PasswordlessInitiateBody}> = (props) => {
          const {data} = props ?? {};

          return  passwordlessInitiate(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PasswordlessInitiateMutationResult = NonNullable<Awaited<ReturnType<typeof passwordlessInitiate>>>
    export type PasswordlessInitiateMutationBody = PasswordlessInitiateBody
    export type PasswordlessInitiateMutationError = BadRequestResponse | InternalServerErrorResponse

    /**
 * @summary Initiate passwordless authentication
 */
export const usePasswordlessInitiate = <TError = BadRequestResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordlessInitiate>>, TError,{data: PasswordlessInitiateBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getPasswordlessInitiateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Verifies the OTP code sent to user's email and returns authentication tokens.

 * @summary Verify OTP code for passwordless authentication
 */
export const passwordlessVerify = (
    passwordlessVerifyBody: PasswordlessVerifyBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PasswordlessVerify200>(
      {url: `https://api.app.usesky.ai/auth/passwordless/verify`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: passwordlessVerifyBody
    },
      options);
    }
  


export const getPasswordlessVerifyMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordlessVerify>>, TError,{data: PasswordlessVerifyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof passwordlessVerify>>, TError,{data: PasswordlessVerifyBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof passwordlessVerify>>, {data: PasswordlessVerifyBody}> = (props) => {
          const {data} = props ?? {};

          return  passwordlessVerify(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type PasswordlessVerifyMutationResult = NonNullable<Awaited<ReturnType<typeof passwordlessVerify>>>
    export type PasswordlessVerifyMutationBody = PasswordlessVerifyBody
    export type PasswordlessVerifyMutationError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Verify OTP code for passwordless authentication
 */
export const usePasswordlessVerify = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof passwordlessVerify>>, TError,{data: PasswordlessVerifyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getPasswordlessVerifyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Removes the current session
 */
export const logoutUser = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<LogoutUser200>(
      {url: `https://api.app.usesky.ai/logout`, method: 'post'
    },
      options);
    }
  


export const getLogoutUserMutationOptions = <TError = unknown,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,TVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,TVariables, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof logoutUser>>, TVariables> = () => {
          

          return  logoutUser(requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type LogoutUserMutationResult = NonNullable<Awaited<ReturnType<typeof logoutUser>>>
    
    export type LogoutUserMutationError = unknown

    /**
 * @summary Removes the current session
 */
export const useLogoutUser = <TError = unknown,
    TVariables = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof logoutUser>>, TError,TVariables, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getLogoutUserMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Refresh the access token using a refresh token
 */
export const refreshAccessToken = (
    refreshAccessTokenBody: RefreshAccessTokenBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RefreshAccessToken200>(
      {url: `https://api.app.usesky.ai/refresh-token`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: refreshAccessTokenBody
    },
      options);
    }
  


export const getRefreshAccessTokenMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError,{data: RefreshAccessTokenBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError,{data: RefreshAccessTokenBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof refreshAccessToken>>, {data: RefreshAccessTokenBody}> = (props) => {
          const {data} = props ?? {};

          return  refreshAccessToken(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type RefreshAccessTokenMutationResult = NonNullable<Awaited<ReturnType<typeof refreshAccessToken>>>
    export type RefreshAccessTokenMutationBody = RefreshAccessTokenBody
    export type RefreshAccessTokenMutationError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Refresh the access token using a refresh token
 */
export const useRefreshAccessToken = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof refreshAccessToken>>, TError,{data: RefreshAccessTokenBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getRefreshAccessTokenMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Complete the new password challenge for first-time login
 */
export const completeNewPassword = (
    completeNewPasswordBody: CompleteNewPasswordBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CompleteNewPassword200>(
      {url: `https://api.app.usesky.ai/complete-new-password`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: completeNewPasswordBody
    },
      options);
    }
  


export const getCompleteNewPasswordMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeNewPassword>>, TError,{data: CompleteNewPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof completeNewPassword>>, TError,{data: CompleteNewPasswordBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeNewPassword>>, {data: CompleteNewPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  completeNewPassword(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type CompleteNewPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof completeNewPassword>>>
    export type CompleteNewPasswordMutationBody = CompleteNewPasswordBody
    export type CompleteNewPasswordMutationError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse

    /**
 * @summary Complete the new password challenge for first-time login
 */
export const useCompleteNewPassword = <TError = BadRequestResponse | UnauthorizedResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeNewPassword>>, TError,{data: CompleteNewPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getCompleteNewPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Initiate password reset process
 */
export const forgotPassword = (
    forgotPasswordBody: ForgotPasswordBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ForgotPassword200>(
      {url: `https://api.app.usesky.ai/forgot-password`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordBody
    },
      options);
    }
  


export const getForgotPasswordMutationOptions = <TError = BadRequestResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordBody
    export type ForgotPasswordMutationError = BadRequestResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Initiate password reset process
 */
export const useForgotPassword = <TError = BadRequestResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary Complete password reset with verification code
 */
export const resetPassword = (
    resetPasswordBody: ResetPasswordBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ResetPassword200>(
      {url: `https://api.app.usesky.ai/reset-password`, method: 'post',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordBody
    },
      options);
    }
  


export const getResetPasswordMutationOptions = <TError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext> => {
 const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,requestOptions)
        }

        


   return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordBody
    export type ResetPasswordMutationError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | InternalServerErrorResponse

    /**
 * @summary Complete password reset with verification code
 */
export const useResetPassword = <TError = BadRequestResponse | UnauthorizedResponse | NotFoundResponse | InternalServerErrorResponse,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, request?: SecondParameter<typeof customInstance>}
) => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions);
    }
    